import '../assets/NcActionCaption-Bp8mrIk7.css';
import { n as t } from "../chunks/_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const a = {
  name: "NcActionCaption",
  inject: {
    isInSemanticMenu: {
      from: "NcActions:isSemanticMenu",
      default: !1
    }
  },
  props: {
    /**
     * The caption's text
     */
    name: {
      type: String,
      required: !0
    }
  }
};
var i = function() {
  var n = this, e = n._self._c;
  return e("li", { staticClass: "app-navigation-caption", attrs: { role: n.isInSemanticMenu && "presentation" } }, [n._v(" " + n._s(n.name) + " ")]);
}, r = [], s = /* @__PURE__ */ t(
  a,
  i,
  r,
  !1,
  null,
  "7c8f7463",
  null,
  null
);
const _ = s.exports;
export {
  _ as default
};
